import React from 'react';
import { NavLink } from "react-router-dom";
import { useAuth } from '../teacher/AuthContext';

const Assessment_attributes = () => {
  // Pull context data so 'currentUser' can be used down below without breaking the page
  const auth = useAuth();
  const currentUser = auth?.currentUser;
  return (
    <div className='fixed top-24 right-0 left-0 justify-items-stretch w-full content-center items-center'>
     <div className="h-12 flex bg-[#007bff] justify-between gap-4"> 

{/*<Link to="/tutoring/find" className=' text-black text-lg flex'>Find a Tutor</Link>*/}
<NavLink to="/assessment/assess_dev" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }
      >Assessment Development</NavLink>
{/*<NavLink to="/tutoring/learner" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Learners</NavLink>*/} 

<NavLink to="/assessment/assess_rep" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Score Reporting</NavLink>
<NavLink to="/assessment/assess_cli" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Clientele</NavLink>

<NavLink to="/assessment/assess_too" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Assessment Tools</NavLink>

<NavLink to="/assessment/assess_con" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Contact</NavLink>
{/*<Link to="/tutoring/tutors" className=' text-black text-lg flex'>Demo1</Link>*/}
{/*<Link to="/tutoring/tutors1" className=' text-black text-lg flex'>Demo2</Link>*/}
{/* CONDITIONAL ADMIN DASHBOARD: Only shows if user is logged in AND has the admin role */}
      {/*  {currentUser && currentUser.role === 'admin' && (
<NavLink to="//admin-dashboard" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>AdminDashBoard</NavLink>
      )}
{/*<Link to="/tutoring/tutors_20" className=' text-black text-lg flex'>Book</Link>
<NavLink to="/tutoring/tutors_23" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Book a Tutor</NavLink>
        {/* EDIT PROFILE LINK: This maps directly to your CompleteProfile component via routes 
{currentUser && ['tutor'].includes(currentUser.role) && (
<NavLink to="/tutoring/complete_profile" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Edit Profile</NavLink>
      )}
        <NavLink to="/tutoring/subjectpages_4" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }>Grade Four</NavLink>
 CONDITIONAL AUTH SECTION 
        {window.currentUser ? (
          <div className=" inline-block ml-20">
            <NavLink to="/tutoring/profile" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }>
              Hi, {currentUser.email.split('@')[0]}
            </NavLink>
        <button 
              onClick={logout} 
             className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
            >
              Logout
            </button>
          </div>
          ) : (
          <NavLink to="/login" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }>
            Login
          </NavLink>
        )}*/}
      </div>
      </div> 
        

    
  );
}

export default Assessment_attributes;